import React from 'react';

import Header from 'buyside/components/presentation/Feed/CorporateAction/Header/header';
import SingleEntityDisplay from 'buyside/components/presentation/Feed/CorporateAction/SingleEntityDisplay/singleEntityDisplay';
import DualEntityDisplay from 'buyside/components/presentation/Feed/CorporateAction/DualEntityDisplay/dualEntityDisplay';

const CorporateAction = ({ corporateAction, currentUser }) => {
  const timeframe = corporateAction.actionType.match('seven') ? '7' : '30';

  return (
    <div>
      <Header corporateAction={corporateAction} timeframe={timeframe} />
      {corporateAction.childEntity ? (
        <DualEntityDisplay {...corporateAction} timeframe={timeframe} currentUser={currentUser} />
      ) : (
        <SingleEntityDisplay {...corporateAction} timeframe={timeframe} currentUser={currentUser} />
      )}
    </div>
  );
};

export default CorporateAction;
